import { render, staticRenderFns } from "./DeviceTemplates.vue?vue&type=template&id=4a1320a8&scoped=true&"
import script from "./DeviceTemplates.vue?vue&type=script&lang=js&"
export * from "./DeviceTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1320a8",
  null
  
)

export default component.exports